import {AppConfig, BaseApp, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS} from "../shared/colors";
import {Main} from "./Main";
import {PathComponent} from "../index";
import {FIREBASE_CONFIG} from "../consts";
import {BORDER_RADIUS, SZ_SM} from "../shared/dimens";
import {Auth, indexedDBLocalPersistence, initializeAuth} from "@firebase/auth";
import {FirebaseApp} from "firebase/app";
import {Capacitor} from "@capacitor/core";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {ProvisionedAppConfig} from "../shared/types";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export const COLOR_PRIMARY = "#222";

export const COLOR_BG1 = "#2f8f4f";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          fontSize: "75%",
          borderRadius: BORDER_RADIUS,
        },
      }
    },
  },
  typography: {
    h1: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h2: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h3: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h4: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h5: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    h6: {
      fontWeight: "bold",
      lineHeight: 1,
    },
    fontSize: 13,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: "#000",
      contrastText: "#fff",
    },
    background: {
      default: COLOR_BG1,
    },
  }
};

export const THEME = createTheme(THEME_OPTIONS);

export class App extends ProvisionedApp<AppProps, AppState> {

  protected getAuth(app: FirebaseApp): Auth {
    return Capacitor.isNativePlatform()
      ? initializeAuth(app, {
        persistence: indexedDBLocalPersistence
      })
      : super.getAuth(app);
  }

  getProvisionedAppId(): string {
    return "chess";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "Chess",
      icon: "/icon.png",
      logo: "/logo192.png",
      stamp: "/stamp.png",
      stampHeight: SZ_SM,
      stampText: "Chess ♞",
      safeAreaInsets: {
        bottom: Capacitor.getPlatform() === "ios" ? 12 : 0,
      },
      defaultUserImage: "/images/default_user.png",
      theme: THEME,
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected renderMain(): ReactElement {
    return <>
      <Main path={this.props.path}/>
    </>;
  }
}
